$(document).ready(function(){
   
    $(document).on("click", function(event){
        var $trigger = $(".dropdown");
        if($trigger !== event.target && !$trigger.has(event.target).length){
            $(".dropdown-menu-top").slideUp("fast");
        }
    });
    
});

//This is used to show the logout menu
function clickDropdownClass(){
    $(".dropdown").click(function(){
        $(this).find(".dropdown-menu-top").slideToggle("fast");
    });
}

function showJSToolTip(tagNameAttr) {
    const elements = document.getElementsByName(tagNameAttr);
    if (elements.length === 0) {
        return;
    }

    const tag = $(elements[0]);

    if (tag.attr("alt") === "1") {
        return;
    }

    const nextTag = tag.next().is("span") === true ? tag.next() : tag.parent().next();

    nextTag.fadeIn(100);
}

function hideJSToolTip(tagNameAttr) {
    const elements = document.getElementsByName(tagNameAttr);
    if (elements.length === 0) {
        return;
    }

    const tag = $(elements[0]);

    const nextTag = tag.next().is("span") === true ? tag.next() : tag.parent().next();

    nextTag.fadeOut(100);
}
